import React from 'react'
import ContactDetails from '../../components/User/Contact/Contactdetails'
import SimpleBanner from '../../components/User/Common/SimpleBanner'
import GetInTouch from '../../components/User/Contact/Getintouch'

const Contact = () => {
  return (
    <div>
      <SimpleBanner title='Contact Us' subheading='Home > Contact Us'/>
      <ContactDetails/>
      <GetInTouch/>
    </div>
  )
}

export default Contact